<div class="d-flex flex-column gap-3">
    <ng-container>
        <div class="d-flex flex-row gap-1 pb-1 overflow-auto">
            <ng-container *ngFor="let year of availableYears">
                <button class="badge  p-2 text-semi-bold" (click)="setFilteredYear(year)"
                    [ngClass]="year == selectedYear ? 'badge-primary' : 'badge-default'">
                    {{year}}
                </button>
            </ng-container>
        </div>

        <!-- Loading -->
        <app-spinner *ngIf="(assignmentBillingPeriodsSubject | async) == null"></app-spinner>

        <div class="d-flex flex-column gap-2" *ngIf="assignmentBillingPeriodsSubject | async as periods">
            <div class="alert alert-secondary" *ngIf="!periods.length">
                {{'assignments.billedAssignments.emptyList' | transloco}}
            </div>

            <a *ngFor="let period of periods" [routerLink]="['/assignments','billed',period.id]"
                class="text-decoration-none">
                <div class="text-decoration-none text-dark w-100 shadow-sm p-3 bg-white d-block rounded">
                    <div class="d-flex align-items-center gap-3 w-100">
                        <div class="flex-grow-1 overflow-hidden text-start">
                            <div class="d-flex align-items-center">
                                <i class="fa-regular fa-calendar-days me-1"></i>
                                <span class="fs-4 mb-0 fw-regular text-start text-nowrap">
                                    {{period.period}}
                                </span>
                            </div>
                            <div class="fs-4 mb-0 fw-bold">
                                <p class="fs-4 fw-regular">
                                    <b>{{'assignments.billedAssignments.payoutMonth' | transloco}}: </b>
                                    <span style="white-space: nowrap;">
                                        {{period.payoutMonth}}
                                    </span>
                                </p>

                            </div>
                            <div class="fs-4 mb-0 fw-bold">
                                <p class="fs-4 fw-regular">
                                    <b>{{'assignments.billedAssignments.totalSalary' | transloco}}: </b>
                                    <span style="white-space: nowrap;">
                                        {{'shared.swissFranc' |transloco}} {{ period.totalSalary| number: '1.2-2'}}
                                    </span>
                                </p>

                            </div>
                        </div>
                        <div>
                            <i class="fa fa-chevron-right text-primary"></i>
                        </div>
                    </div>
                </div>
            </a>
        </div>

    </ng-container>
</div>